export enum EventDetailsProperties {
  EventTimeStamp = 'TimeStamp',
  EventSource = 'Source',
  MachineName = 'Machine',
  EventDescription = 'Description',
  EventStatus = 'Status',
  EventSeverity = 'Event Severity',
  EventId = 'Event Id',
  IpAddress = 'IpAddress',
  LoggedinUser = 'User',
  Type = 'Type',
  Parameters = 'Parameters',
  ExecutionTime = 'Execution Time',
}
